import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { JWT_LOCAL_STORAGE_KEY } from '../constants/constants';
import { environment } from '../environments/environment';
import localStorage from './localStorage';

const client = axios.create({
  baseURL: environment.backendUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const newConfig = {
      ...(config as AxiosRequestConfig),
      headers: config.headers as AxiosRequestHeaders,
    };
    const jwtToken = localStorage.get(JWT_LOCAL_STORAGE_KEY);
    if (newConfig.headers && jwtToken) {
      newConfig.headers.Authorization = `Bearer ${jwtToken}`;
    }
    return newConfig;
  },
  (error) => {
    throw error;
  },
);

client.interceptors.response.use(
  async (response) => response.data,
  (error) => {
    throw error;
  },
);

export function setHttpErrorInterceptor(callback: ((error: Error) => void) | null) {
  return client.interceptors.response.use(
    undefined,
    (error) => {
      if (callback) {
        callback(error as Error);
      } else {
        throw error;
      }
    },
  );
};


export function clearHttpErrorInterceptor(interceptorId: number) {
  client.interceptors.response.eject(interceptorId);
};

export default client;
